<template>
  <scout-topic-panel
    title="いいね済み"
    name="like"
    :notice-background="!isAutoLikedEnabled && canSendLiked"
  >
    <router-link
      :to="{ name: 'scoutLiked', params: { contractId: contractId + '' , jobId: jobId + ''} }"
      class="pega-text-link pega-mb-5"
      data-test="liked-count-link"
    >
      <span
        data-test="count"
        class="boss-scoutandlike-text"
      >{{ count }}名</span>
    </router-link>
    <template v-if="isAutoLikedEnabled && canSendLiked">
      <small>
        <div data-test="is-setting-auto-liked-1">
          いいね自動送信を設定中
        </div>
        <div data-test="is-setting-auto-liked-2">
          設定変更・確認は
          <router-link
            :to="{ name: 'settingAutoLikedTop' }"
            data-test="auto-liked-link"
          >
            <span
              data-test="link"
              class="pega-link-text"
            >こちら</span>
          </router-link>
          から
        </div>
      </small>
    </template>
    <template v-else-if="!isAutoLikedEnabled && canSendLiked">
      <div
        class="pega-notice-default-font-size"
        data-test="is-not-setting-auto-liked-1"
      >
        いいね自動送信が設定されていません
      </div>
      <div data-test="is-not-setting-auto-liked-2">
        設定は
        <router-link
          :to="{ name: 'settingAutoLikedTop' }"
          data-test="auto-liked-link"
        >
          <span
            data-test="link"
            class="pega-link-text"
          >こちら</span>
        </router-link>
        から
      </div>
    </template>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'

export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    isAutoLikedEnabled: {
      type: Boolean,
      default: false
    },
    canSendLiked: {
      type: Boolean,
      default: true
    }
  }
}

</script>
